var map = {
	"./adult/de/4 1 Skrivehastighet Intro.mp3": 829,
	"./adult/nn/4 1 Skrivehastighet Intro.mp3": 830,
	"./adult/no/4 1 Skrivehastighet Intro.mp3": 831,
	"./youth/de/4 1 Skrivehastighet Intro.mp3": 832,
	"./youth/nn/4 1 Skrivehastighet Intro.mp3": 833,
	"./youth/no/4 1 Skrivehastighet Intro.mp3": 834,
	"./youth/se/4 1 Skrivehastighet Intro.mp3": 835
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 828;